import React, {Component} from 'react';

import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import axios from "axios";
import {connect} from 'react-redux';
import {givePrivileges,getPrivilegesWithRegions} from '../actions/privilegeActions'
import _ from 'lodash';
import {withSnackbar} from 'notistack';
import urlConfig from '../config'
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import {Typography} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import OTTService from "../Services/OTTService";
import MenuItem from "@material-ui/core/MenuItem";
import MomentsService from "../Services/MomentsService";
import CollectionInput from "./CollectionInput";
import {addToList, handleReOrder, isSaved} from "../Utilities/List";
import Sortable from "react-sortablejs";
import showSnackBar from "../Utilities/SnackbarHelper";
import {ERROR, SUCCESS, WARNING} from "../constants";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import ReactGA from 'react-ga';
import { MOMENTS_COLLECTIONS, CREATE_NEW_COLLECTION, SAVE_COLLECTION_ORDER, REORDER_MULTIPLE_COLLECTION, DELETE_COLLECTION } from '../Utilities/GAUtils';

const styles = theme => ({
    container: {
        position: 'relative',
        minHeight: "100vh"
    },
    searchBar: {
        flex: 1
    },
    playlistClipMomentsContainer: {},
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    newCollectionButton: {
        marginBottom: theme.spacing(2)
    }
});


class Collection extends Component {

    constructor(props) {
        super(props);

        this.state = {
            expanded: "panel1",
            region: {},
            subregion: {},
            product: {},
            collections: [],
            mode: 'init',
            authenticationDone: false,
            collectionIdToDelete:'',
            deleteDialogOpen : false
        };

        this.handleSuggestionSelect = this.handleSuggestionSelect.bind(this);
    }

    setDefaultValueForAllDropdown = (regions) => {
        this.setState({mode:'ready',region : regions[0], subregion : regions[0].subregions[0],
            product: regions[0].subregions[0].products[0], collections:[]}) 
        this.getMomentsCollection(regions[0].id,regions[0].subregions[0].id,regions[0].subregions[0].products[0].id)
    }

    componentDidMount() {

        let self = this;
        if (this.props.privileges && this.props.privileges.regions && this.props.privileges.regions.length > 0 && 
            this.props.privileges.regions[0].subregions[0] && this.props.privileges.regions[0].subregions[0].products[0] )
        {
            this.setDefaultValueForAllDropdown(this.props.privileges.regions);
        }
        
    }

    componentWillUnmount() {

    }

    handleChange = element => event => {
        let self = this;
        this.setState({
            [element]: event.target.value,
        }, function () {
            if (element === "region") {
                let subregionToSet = {};
                // console.log(self.state.region.subregions[0]);
                // if(self.state.region.subregions && self.state.region.subregions.length>0){
                //     subregionToSet = self.state.region.subregions[0];
                // }
                self.setState({mode: 'init', subregion: subregionToSet, collections: []});
            }
            if (element === "subregion") {
                let productToSet = {};
                // if(self.state.subregion.products && self.state.subregion.products.length>0){
                //     productToSet = self.state.subregion.products[0];
                // }
                self.setState({mode: 'init', product: productToSet, collections: []})
            }
            if (element === "product") {
                self.setState({mode: 'ready', collections: []});
                self.loadCollections();
            }

        });
    };

    loadCollections() {
        let self = this;
        this.getMomentsCollection(self.state.region.id, self.state.subregion.id, self.state.product.id);
    }

    getMomentsCollection = (regionId, subregionId,productId) => {
        let self = this;
        MomentsService.getMomentsCollection(regionId,subregionId,productId)
        .then((response) => {
            if (response && response.data && response.data.entity && response.data.entity.length > 0) {
                let collections = response.data.entity;
                self.setState({collections: collections});
            } else {
                self.setState({collections: []});
            }
        })

    }

    handleChangePanel = panel => (event, isExpanded) => {
        this.setState({expanded: isExpanded ? panel : false});
    };


    handleSuggestionSelect(event) {
        let self = this;
        this.setState({cid: event}, () => {

        }, function () {

        })
    }

    addCollection() {
        let collections = this.state.collections;
        let savedFlag = isSaved(collections, 'id');

        if (savedFlag === true) {
            let newCollectionToAdd = {
                region: {id: this.state.region.id, name: this.state.region.name},
                subRegion: {id: this.state.subregion.id, name: this.state.subregion.name},
                product: {id: this.state.product.id, name: this.state.product.name},
            };
            let newCollections = addToList(
                newCollectionToAdd
                , collections, this);
            this.setState({collections: newCollections});
        } else {
            showSnackBar("Please save newly created collection first, before adding a new collection.", WARNING, this);
        }

        ReactGA.ga('send','event',
                MOMENTS_COLLECTIONS,
                CREATE_NEW_COLLECTION,
                `${this.state.region.name}-${this.state.subregion.name}`,
                1)

    }

    confirmDelete(collectionIdToDelete){
        this.setState({collectionIdToDelete:collectionIdToDelete,deleteDialogOpen:true});
    }

    closeDeleteForm(){
        this.setState({collectionIdToDelete:'',deleteDialogOpen:false});
    }

    deleteCollection() {
        let self = this;
        if (this.state.collectionIdToDelete!=="") {
            MomentsService.deleteCollection(this.state.collectionIdToDelete).then((response) => {
                if (response.data && response.data.responseType === "SUCCESS") {
                    self.setState({deleteDialogOpen:false});
                    showSnackBar("Moments collection deleted successfully!", SUCCESS, self);
                    self.loadCollections();
                } else {
                    let errorMessages = "";
                    if (response.data.genericMessage && response.data.genericMessage.ERROR) {
                        errorMessages = errorMessages + response.data.genericMessage.ERROR.join(". ");
                    }
                    showSnackBar(`Moments collection can not be deleted. ${errorMessages}`, ERROR, self);
                }
            })
        }
        ReactGA.ga('send','event',
                MOMENTS_COLLECTIONS,
                DELETE_COLLECTION,
                this.state.collectionIdToDelete,
                1)
    }

    onDragDropPosition(event) {
        let momentsCollectionOrderIDs = event;
        let collections = this.state.collections;
        let newCollections = [];
        newCollections = handleReOrder(momentsCollectionOrderIDs, collections, 'id');
        this.setState({collections: newCollections});
        ReactGA.ga('send', 'event',
                MOMENTS_COLLECTIONS,
                REORDER_MULTIPLE_COLLECTION,
                `${this.state.region.name}-${this.state.subregion.name}`,
                1)
    }

    handleSaveOrder() {
        let self = this;
        let collectionsToSave = this.state.collections;
        let savedFlag = isSaved(collectionsToSave, 'id');

        if (collectionsToSave && collectionsToSave.length > 0) {
            if (savedFlag === true) {

                _.map(collectionsToSave, (collection) => {
                    delete collection.contents; //remove contents as it is not required for save Order
                    return collection;
                });

                MomentsService.saveMomentsCollectionOrder(collectionsToSave).then((response) => {
                    if (response.data && response.data.responseType === "SUCCESS") {
                        showSnackBar("Collection order saved successfully.", SUCCESS, self);
                        self.loadCollections();
                    } else {
                        let errorMessages = "";
                        if (response.data.genericMessage && response.data.genericMessage.ERROR) {
                            errorMessages = errorMessages + response.data.genericMessage.ERROR.join(". ");
                        }
                        showSnackBar(`Error saving collections order. ${errorMessages}`, ERROR, self);
                    }
                })
            } else {
                showSnackBar(`Please save all collections before saving order`, WARNING, self);
            }
        }

        ReactGA.ga('send','event',
                MOMENTS_COLLECTIONS,
                SAVE_COLLECTION_ORDER,
                `${this.state.region.name}-${this.state.subregion.name}`,
                1)

    }

    render() {

        let sortable = null;
        const {classes, theme} = this.props;
        
        return <React.Fragment>

            {this.props.privileges && this.props.privileges.regions && this.props.privileges.regions.length > 0 &&
            <Card className={classes.container}>
                <CardContent>

                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <FormControl fullWidth className={classes.formControl}>
                                <InputLabel htmlFor="region">Region</InputLabel>
                                <Select
                                    value={this.state.region}
                                    onChange={this.handleChange('region')}
                                    inputProps={{
                                        name: 'region',
                                        id: 'region',
                                    }}
                                >
                                    {_.map(this.props.privileges.regions, (region, index) => {
                                        return <MenuItem key={index} value={region}>{region.name}</MenuItem>
                                    })
                                    }

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>

                            <FormControl fullWidth className={classes.formControl}>
                                <InputLabel htmlFor="subregion">Subregion (Flavour)</InputLabel>
                                <Select
                                    value={this.state.subregion}
                                    onChange={this.handleChange('subregion')}
                                    inputProps={{
                                        name: 'subregion',
                                        id: 'subregion',
                                    }}
                                >
                                    {_.map(this.state.region.subregions, (subregion, index) => {
                                        return <MenuItem value={subregion} key={index}>{subregion.name}</MenuItem>
                                    })
                                    }

                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth className={classes.formControl}>
                                <InputLabel htmlFor="subregion">Platform (Product)</InputLabel>
                                <Select
                                    value={this.state.product}
                                    onChange={this.handleChange('product')}
                                    inputProps={{
                                        name: 'product',
                                        id: 'product',
                                    }}
                                >
                                    {_.map(this.state.subregion.products, (product, index) => {
                                        return <MenuItem value={product} key={index}>{product.name}</MenuItem>
                                    })
                                    }

                                </Select>
                            </FormControl>
                        </Grid>


                    </Grid>

                    {(this.state.deleteDialogOpen === true) &&
                    <Dialog
                        open={this.state.deleteDialogOpen}
                        onClose={this.closeDeleteForm.bind(this)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{`Delete moments collection with ID ${this.state.collectionIdToDelete}?`}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                This moments collection will be permanently deleted from the system and can not be recovered.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.closeDeleteForm.bind(this)} color="default" autoFocus>
                                No
                            </Button>
                            <Button onClick={this.deleteCollection.bind(this)} variant={"contained"} color="secondary">
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>
                    }

                    {this.state.mode === 'ready' &&
                    <React.Fragment>
                        <br/>
                        <Button color={"primary"} onClick={this.addCollection.bind(this)}
                                className={classes.newCollectionButton} variant={"contained"}>
                            Create new collection
                        </Button>


                        <div>
                            <Sortable
                                options={{handle: '.handler'}}
                                ref={(c) => {
                                    if (c) {
                                        sortable = c.sortable;
                                    }
                                }}
                                tag={'div'}
                                onChange={(order, sortable, evt) => {
                                    let flagIsSaved = true;
                                    order.map(orderElm => {
                                        let orderElementInt = parseInt(orderElm);
                                        if (!Number.isInteger(orderElementInt)) {
                                            flagIsSaved = false;
                                        }
                                    });
                                    if (flagIsSaved === true) {
                                        this.onDragDropPosition(order);
                                    } else {
                                        showSnackBar("Please save all collections before reordering.", WARNING, this);
                                    }

                                }}
                            >
                                {_.map(this.state.collections, (collection, index) => (
                                    <div key={index} data-id={collection.id}>
                                        <CollectionInput collection={collection} key={collection.id}
                                                         loadCollections={this.loadCollections.bind(this)}
                                                         deleteCollection={this.confirmDelete.bind(this)}/>
                                    </div>))

                                }

                            </Sortable>
                        </div>


                        {this.state.collections && this.state.collections.length > 0 &&
                        <Grid container spacing={0}
                              direction="row"
                              justify="center"
                              alignItems="center">
                            <Grid item xs={4}></Grid>
                            <Grid item xs={2}>
                                <Button variant={"contained"} type={'button'} onClick={this.handleSaveOrder.bind(this)}
                                        color={"primary"}>Save Order</Button>
                            </Grid>
                            <Grid item xs={4}></Grid>

                        </Grid>
                        }


                    </React.Fragment>}
                </CardContent>

            </Card>
            }

            {((!this.state.regions) || (this.state.regions.length === 0)) && this.state.authenticationDone === true &&
            <Typography variant={"body2"}>
                Since you do not have access to any region on the OTT tool, you can not create moments.
            </Typography>
            }


        </React.Fragment>
    }
}

const mapStateToProps = (state) => {
    return {
        privileges: state.privilege.privileges
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPrivilegesWithRegions: () => dispatch(getPrivilegesWithRegions())
    }
};

Collection.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, {withTheme: true})(withSnackbar(Collection)));
